import * as React from "react";
import BaseComponent from "components/BaseComponent";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import {Errors} from "components/DataBaseComponent/DataBaseComponent";
import CodeEditor, {TextFormat} from "components/CodeEditor/CodeEditor";
import {DataContext, MetadataTypeCollection} from "client/resources/dynamicFormResources";
import {repository} from "clientInstance";

interface SourceCodeDialogProps {
    template: string;
    textFormat?: TextFormat;
    metadata: string;
    saveDone(newTemplate: string, metadata: {Metadata: MetadataTypeCollection, Values: DataContext}): any;
    doBusyTask(action: () => Promise<void>): Promise<boolean>;
}

interface SourceCodeDialogState {
    template: string;
    metadata: {Metadata: MetadataTypeCollection, Values: DataContext};
    errors?: Errors;
}

class SourceCodeDialog extends BaseComponent<SourceCodeDialogProps, SourceCodeDialogState> {
    constructor(props: any) {
        super(props);
        this.state = {
            errors: null,
            metadata: null,
            template: this.props.template
        };
    }

    getMetadata(template: string): Promise<{Metadata: MetadataTypeCollection, Values: DataContext}> {
        return repository.CloudTemplates.getMetadata(template, this.props.metadata);
    }

    async save() {
        try {
            const metadata = await this.getMetadata(this.state.template);
            this.props.saveDone(this.state.template, metadata);
            return true;
        } catch (err) {
            this.setState({errors: {message: err.ErrorMessage, details: err.Errors ? err.Errors.map((x: string) => x.toString()) : null, fieldErrors: {}}});
            return false;
        }
    }

    render() {
        return <SaveDialogLayout title={"Template source code"}
                                 busy={null}
                                 errors={this.state.errors}
                                 onSaveClick={() => this.save()}
                                 saveButtonLabel={"OK"}>
            <CodeEditor value={this.state.template}
                        language={this.props.textFormat || TextFormat.JSON}
                        allowFullScreen={false}
                        onChange={(template) => { this.setState({template}); }}
            />
        </SaveDialogLayout>;
    }
}

export default SourceCodeDialog;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/SourceCodeDialog/sourceCodeDialog.tsx